<template>
  <!-- 物料类型的表单 -->
  <div>
    <el-form ref="typeForm" :model="formData" label-width="110px">
      <el-row>
        <el-col span="12">
          <el-form-item label="项目名称：" prop="projectId" required>
            <el-select
              style="width: 100%"
              v-model="formData.projectId"
              placeholder="请选择 项目名称"
              disabled
            >
              <el-option
                v-for="(item, index) in projectList"
                :key="index"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <template v-if="!formData.isRoot">
          <el-col span="12">
            <el-form-item label="上级名称：" prop="parentName">
              <el-input v-model="formData.parentName" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col span="12">
            <el-form-item label="上级编码：" prop="parentCode">
              <el-input v-model="formData.parentCode" disabled></el-input>
            </el-form-item>
          </el-col>
        </template>
        <el-col span="12">
          <el-form-item
            :label="formData.isRoot ? '类型名称' : '下级名称：'"
            prop="name"
            :rules="[
              { required: true, message: formData.isRoot ? '请输入类型名称' : '请输入下级名称：' },
            ]"
          >
            <el-input
              :maxlength="20"
              :show-word-limit="true"
              clearable
              v-model="formData.name"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col span="12">
          <el-form-item
            label="类型编码："
            prop="code"
            :rules="[{ required: true, message: '请输入类型编码' }]"
          >
            <el-input
              :maxlength="30"
              :show-word-limit="true"
              clearable
              v-model="formData.code"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col span="12">
          <el-form-item label="完整编码：">
            <el-input
              :value="(formData.parentCode || '') + (formData.code || '')"
              disabled
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col span="12">
          <el-form-item
            label="排序："
            prop="sort"
            :rules="[{ required: true, message: '请输入排序' }]"
          >
            <el-input
              v-model.number="formData.sort"
              :maxlength="6"
              :show-word-limit="true"
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col span="24">
          <div style="float: right;">
            <el-button type="primary" size="small" @click="doSave">提交</el-button>
            <el-button size="small" @click="doClose">取消</el-button>
          </div>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import { getProjectListApi } from '@/api/warehouse/index';
import { add, update } from '@/api/crmedical/warehouse/warehouseconsumabletype';

export default {
  name: 'WarehouseConsumableTypeForm',
  props: ['formData'],
  data() {
    return {
      projectList: [],
    };
  },
  created() {
    getProjectListApi().then(({ data }) => {
      this.projectList = data || [];
    });
  },
  methods: {
    /* 保存 */
    doSave() {
      this.$refs.typeForm.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '提交中...',
            spinner: 'el-icon-loading',
          });
          let formType = this.formData.formType;
          let fn = formType == 'add' ? add : update;
          let params = {
            projectId: this.formData.projectId,
            parentId: this.formData.isRoot ? 0 : this.formData.parentId,
            name: this.formData.name,
            code: this.formData.code,
            sort: this.formData.sort,
          };
          if (formType == 'edit') {
            params.id = this.formData.id;
          }
          fn(params)
            .then(() => {
              loading.close();
              this.$message.success('操作成功!');
              this.$emit('update');
            })
            .catch(() => {
              loading.close();
            });
        }
      });
    },
    doClose() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
.btns {
  display: flex;
  justify-content: flex-end;
}
</style>
